import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::store
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:27
* @route '/auth/whatsapp-notifications'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/auth/whatsapp-notifications',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::store
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:27
* @route '/auth/whatsapp-notifications'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::store
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:27
* @route '/auth/whatsapp-notifications'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::store
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:27
* @route '/auth/whatsapp-notifications'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::store
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:27
* @route '/auth/whatsapp-notifications'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const whatsappNotifications = {
    store: Object.assign(store, store),
}

export default whatsappNotifications